import React, { forwardRef, useEffect, useRef, useState } from "react";
import AlertCircleIcon from "../../../../../shared/icons/AlertCircleIcon";
import GeneralInputWrapper from "../GeneralInputWrapper/GeneralInputWrapper";
import styles from "./FileUploadInput.module.scss";
import TrashIcon from "../../../../../shared/icons/TrashIcon";
import ImportIcon from "../../../../../shared/icons/ImportIcon";
import UploadSpinner from "./UploadSpinner";
import { uploadFileMutation } from "../../form-helpers";
const FileUploadInput = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id,
    isError,
    formId,
    fieldSettings,
    sectionId,
    formSubmitSucceeded,
    sectionValueId,
    onChange,
    uploadFileUrl,
    text,
    elementId,
    wuiltContext
  } = props;
  const uploadInput = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [file, setFile] = useState(null);
  const [error, setError] = useState(false);
  const acceptedFileTypes = fieldSettings.allowSpecificFileTypes ? `${fieldSettings.allowedExtensions}` : "";
  const allowedTypes = fieldSettings?.allowedExtensions;
  const onUploadFile = async e => {
    setError(false);
    if (!uploadFileUrl || !e.target.files?.[0] || !id || !formId || !sectionId || !sectionValueId) {
      return;
    }
    const uploadedFile = e.target.files[0];
    const fileSize = uploadedFile.size / 1024 / 1024;
    const fileType = uploadedFile.name.split(".").pop();
    const siteData = wuiltContext?.props?.site;
    const planId = siteData?.plan?.id;
    const isBusiness = planId === 16 || planId === 19;
    const isUltimate = planId === 17 || planId === 20;
    const sizeLimit = isBusiness ? 10 : isUltimate ? 100 : 25;
    setUploading(true);
    setFile(null);
    if (fileSize < sizeLimit && (!fieldSettings.allowSpecificFileTypes || fileType && allowedTypes?.includes(fileType))) {
      const fileUrl = await uploadFileMutation(uploadFileUrl, e.target.files?.[0], id, formId, sectionId, sectionValueId, elementId);
      setUploading(false);
      if (fileUrl?.uploaded_files) {
        setFile(uploadedFile);
        onChange(fileUrl?.uploaded_files[0]?.url);
      } else {
        setError(true);
        setUploading(false);
      }
    } else {
      setError(true);
      setUploading(false);
    }
  };
  const deleteFile = () => {
    setFile(null);
    onChange(undefined);
    uploadInput.current.value = "";
  };
  const openInputFilePopUp = () => {
    uploadInput.current.click();
  };
  useEffect(() => {
    if (formSubmitSucceeded) {
      setFile(null);
    }
  }, [formSubmitSucceeded]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles.fileUploadContainer}`
  }, /*#__PURE__*/React.createElement(GeneralInputWrapper, {
    isError: error || isError,
    wuiltContext: wuiltContext
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    onClick: openInputFilePopUp,
    className: styles.inputContainer
  }, uploading && /*#__PURE__*/React.createElement(UploadSpinner, null), file ? /*#__PURE__*/React.createElement("span", {
    className: styles.fileName
  }, file?.name) : /*#__PURE__*/React.createElement("span", {
    className: styles.NoFileSelectedText
  }, text[fieldSettings?.placeholder?.textId])), isError || error ? /*#__PURE__*/React.createElement(AlertCircleIcon, null) : null), file ? /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    onClick: deleteFile,
    className: styles.fileUploadButton
  }, /*#__PURE__*/React.createElement(TrashIcon, {
    color: "#D21C1C"
  })) : /*#__PURE__*/React.createElement("div", {
    className: styles.fileUploadButton,
    "aria-hidden": "true",
    onClick: openInputFilePopUp
  }, /*#__PURE__*/React.createElement(ImportIcon, {
    color: "#475467"
  })), /*#__PURE__*/React.createElement("input", {
    id: id,
    accept: acceptedFileTypes,
    ref: uploadInput,
    type: "file",
    className: styles.fileUploadInput,
    onChange: onUploadFile
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.error
  }, error && !isError && text[fieldSettings?.errorMessage?.textId]));
});
FileUploadInput.displayName = "FileUploadInput";
export default FileUploadInput;
//# sourceMappingURL=FileUploadInput.js.map